module.exports = __webpack_public_path__ + "static/media/dff_happy_staff.e1650a0c.png";